import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Debug de démarrage
console.log('[BOOT] main.tsx start');
const rootElement = document.getElementById('root');
console.log('[BOOT] root=', !!rootElement);

// Capture des erreurs globales
window.addEventListener('error', e => {
  console.error('[window.error]', e.message, e.error);
  console.error('[window.error] Stack:', e.error?.stack);
});

window.addEventListener('unhandledrejection', e => {
  console.error('[unhandledrejection]', e.reason);
});

if (!rootElement) {
  console.error('❌ Element #root introuvable !');
} else {
  console.log('✅ MemoMundi.ai - Démarrage de l\'application');
  
  const root = createRoot(rootElement);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}